import { RootState } from '../store';

export const selectIsEmailVerified = (state: RootState) => state.app.isEmailVerified;
export const selectCaptcha = (state: RootState) => state.app.captcha;
export const selectIsAuth = (state: RootState) => state.app.isAuth;
export const selectRemainingTime = (state: RootState) => state.app.remainingTime;
export const select12HourFormat = (state: RootState) => state.app.local.is12HourFormat;
export const selectUserLocale = (state: RootState) => state.app.local.userLocale;

export const selectSnackbarNotify = (state: RootState) => state.modals.notifyAlert;

export const selectIsLoading = (state: RootState) => state.app.isLoading;
export const selectSpecialPage = (state: RootState) => state.app.specialPage;

export const selectAlertDialogInfo = (state: RootState) => state.modals.alertDialog;
export const selectCurrentModal = (state: RootState) => state.modals.currentModal;
export const selectShareModal = (state: RootState) => state.modals.shareModal;
export const selectPermissionModal = (state: RootState) => state.modals.premissionModal;

export const selectMeetingsArgs = (state: RootState) => state.zoom.meetingArgs;
